<template>
    <div class="UserDetails" v-if="user !== null">
        Welcome {{user.name}}

    </div>
</template>

<script>
    export default {
        name: 'UserDetails',
        props: ["user"]

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->